export default __webpack_public_path__ + "static/media/sales-portal.6be5ae1c.png";